import store from '~/store'

export default async (to, from, next) => {
  const user = store.getters['auth/user']
  if (user.role.title !== 'organization_leader') {
    next({ name: 'settings', params: { id: user.id } })
  } else {
    next()
  }
}



// WEBPACK FOOTER //
// ./resources/js/middleware/organization-leader.js